import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const ByContractViewSkeleton: React.FC = () => (
  <div className="rounded-md border">
    <Skeleton className="h-10 w-full rounded-none" />
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="flex h-9 items-center gap-4 border-t px-2">
        <Skeleton className="h-4 w-64" />
        <div className="flex-1" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-24" />
      </div>
    ))}
  </div>
)
export default ByContractViewSkeleton
